import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Button from 'brandComponents/Button';

import {IPasswordToggleProps} from './IPasswordToggle';
import messages from './messages';

import styles from './PasswordToggle.module.scss';

const PasswordToggle = ({value, onClick}: IPasswordToggleProps) => {
	const intl = useIntl();

	return (
		<Button
			type="button"
			showAsLink
			classNames={cn(styles['password-toggle'], 'password-toggle')}
			onClick={onClick}
		>
			{intl.formatMessage(value === 'password' ? messages.show : messages.hide)}
		</Button>
	);
};

export default PasswordToggle;
